import { format } from 'date-fns';
import { HOUR_HEIGHT } from '../../../constants/calendar';

export const TimeLabels = () => (
  <div className="w-20 border-r bg-gray-50" role="rowgroup">
    {Array.from({ length: 24 }, (_, i) => (
      <div
        key={i}
        className="border-t border-gray-200"
        role="row"
        style={{ height: `${HOUR_HEIGHT}px` }}
      >
        <div className="text-xs text-gray-500 -mt-2.5 ml-1">
          {format(new Date().setHours(i, 0, 0, 0), 'HH:mm')}
        </div>
      </div>
    ))}
  </div>
);
